import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { tooltipHide } from '../../../actions/tooltipActions';

// components
import { Button } from '../../shared/_form';
import Modal from '../../shared/_Modal';
import { rejectTradeOffer } from '../../../actions/tradeOffersActions';

class AcceptTradeRequestModal extends React.Component {
    _handleHideModal = () => {
      const { hideTooltip, id } = this.props;

      hideTooltip(id);
    };

    _handleRejectTradeOffer = () => {
      const { tradeOfferId, tradeOfferReject } = this.props;

      tradeOfferReject(tradeOfferId);
    };

    componentWillUnmount() {
      this._handleHideModal();
    }

    render() {
      const { id } = this.props;

      return (
        <Modal id={ id }>
          <div className='modal__header'>
                    Are you sure?
          </div>

          <div>
                    Are you sure you want to reject this trade request?
          </div>

          <div className='modal__actions'>
            <Button className='form__button form__button--purple' onClick={ this._handleRejectTradeOffer } type='button'>Yes</Button>
            <Button className='form__button form__button--green' onClick={ this._handleHideModal } type='button'>No</Button>
          </div>
        </Modal>
      );
    }
}

AcceptTradeRequestModal.propTypes = {
  hideTooltip:        PropTypes.func.isRequired,
  id:                 PropTypes.string,
  tradeOfferReject: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideTooltip: (id) => dispatch(tooltipHide({ id: id })),
    tradeOfferReject: (tradeOfferId) => dispatch(rejectTradeOffer(({ tradeOfferId })))

  };
};

export default connect(null, mapDispatchToProps)(AcceptTradeRequestModal);



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/RejectTradeRequestModal.jsx